// extracted by mini-css-extract-plugin
export var root = "G_vK";
export var wrapper = "G_vL";
export var image = "G_vM d_w d_y d_W";
export var imageWithHeight = "G_vN";
export var crop = "G_vP";
export var round = "G_vQ";
export var fixedHeight = "G_vR";